<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p><a id="page_6"></a>Text copyright © 2013 by <span class="font">Ray Lampe.</span><br/>Photographs copyright © 2013 by <span class="font">Jody Horton.</span><br/>Photographs on pages 15 and 16 courtesy of National Pork Board.<br/>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>ISBN 978-1-4521-2980-8</p>
<p>The Library of Congress has previously cataloged this title under ISBN 978-1-4521-1367-8</p>
<p>Designed by <span class="font">Vanessa Dina</span><br/>Prop and food styling by <span class="font">Kate LeSueur</span><br/>Cooking by <span class="font">Angela Howe</span><br/>Typesetting by <span class="font">DC Type</span></p>
<p>Big Green Egg is a registered trademark of Big Green Egg. Cheez Whiz is a registered trademark of Kraft Foods Holdings Inc. Craisins is a registered trademark of Ocean Spray Cranberries Inc. Frank’s Red Hot Sauce is a registered trademark of Reckitt Benckiser. Homer Simpson is a registered trademark of 20th Century Fox Film Corporation. Morton’s Tender Quick is a registered trademark of Morton International Inc. Pendery’s is a registered trademark of Pendery’s Inc. Sugar In The Raw is a registered trademark of Cumberland Packing Co. Superfast Thermapen is a registered trademark of ThermoWorks. Tater Tots is a registered trademark of Ore-Ida.</p>
<p>For more information about pork, visit<br/><a href="http://PorkBeInspired.com" target="_blank"><span class="font">PorkBeInspired.com</span></a></p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107<br/><a href="http://www.chroniclebooks.com" target="_blank"><span class="font">www.chroniclebooks.com</span></a></p>
</div>
<div class="image_wrap">
<p class="image"><a id="page_5"></a><img alt="image" class="horizontal" src="images/f0005-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05copyright.vue?620daedb